import React from 'react';
import { MailIcon } from 'lucide-react';
import { PaymentBadges } from '../PaymentBadges';
import { SUPPORT_EMAIL } from '../../utils/constants';
const LINKS: string[] = ['Términos y condiciones', 'Política de privacidad', 'Política de reembolsos'];
export function Footer() {
  return <footer className="bg-violeta-profundo text-crema/80 py-14 px-5" data-id="element-117" data-mp="2a609c0e7epad">
      <div className="max-w-6xl mx-auto grid gap-10 md:grid-cols-3" data-id="element-118" data-mp="2a3nuvx7nmx22">
        <div data-id="element-119" data-mp="1mgxpclw3kkcp">
          <p className="font-serif text-lg font-bold text-crema" data-id="element-120" data-mp="1mgflp473v3ur">Pago seguro</p>
          <PaymentBadges className="mt-4 justify-start" data-id="element-121" data-mp="1hie28i5rp2ir" />
        </div>

        <nav aria-label="Enlaces legales" data-id="element-122" data-mp="1w6h87rjt8e7k">
          <p className="font-serif text-lg font-bold text-crema" data-id="element-123" data-mp="1w7abgijk8lky">Legales</p>
          <ul className="mt-4 space-y-2 text-sm" data-id="element-124" data-mp="1reh4rp4j7368">
            {LINKS.map(link => <li key={link} data-id="element-125" data-mp="13omthbzv1mo3">
                <a href="#oferta" className="hover:text-coral transition-colors" data-id="element-126" data-mp="13ntw31msk9im">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>

        <div data-id="element-127" data-mp="1ehkhgodonzdm">
          <p className="font-serif text-lg font-bold text-crema" data-id="element-128" data-mp="1ehtyvnknwy7p">Contacto</p>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="mt-4 inline-flex items-center gap-2 text-sm hover:text-coral transition-colors" data-id="element-129" data-mp="1iicpxfeqe08u">
            <MailIcon className="w-4 h-4" aria-hidden="true" data-id="element-130" data-mp="1sa0ffarq977o" />
            {SUPPORT_EMAIL}
          </a>
        </div>
      </div>

      <div className="max-w-6xl mx-auto mt-10 pt-6 border-t border-white/10 text-xs text-crema/55 leading-relaxed" data-id="element-131" data-mp="vkj70o1d172a">
        <p data-id="element-132" data-mp="zl36hy9eomrl">
          Este material es un entrenamiento de escritura. No constituye diagnóstico ni tratamiento,
          y no reemplaza la consulta con un profesional.
        </p>
        <p className="mt-2" data-id="element-133" data-mp="19jshr86sr8yv">
          © {new Date().getFullYear()} Kit de Caligrafía: 400 Actividades en 21 Días.
        </p>
      </div>
    </footer>;
}